var KEEPALIVE_PING_TIMEOUT = 20000;

var KeepAlive = /*#__PURE__*/function () {
  function KeepAlive(socket) {
    this.keepaliveTimeout = null;
    this.socket = socket;
    this.queue();
  }

  KeepAlive.isPong = function isPong(event) {
    var data = {};

    try {
      data = JSON.parse(event.data);
    } catch (e) {}

    return data.pong === 'PONG';
  };

  KeepAlive.sendPing = function sendPing(socket) {
    socket.send(JSON.stringify({
      ping: 'PING'
    }));
  };

  var _proto = KeepAlive.prototype;

  _proto.clear = function clear() {
    if (this.keepaliveTimeout != null) {
      clearTimeout(this.keepaliveTimeout);
      this.keepaliveTimeout = null;
    }
  };

  _proto.restart = function restart() {
    this.clear();
    this.queue();
  };

  _proto.queue = function queue() {
    this.keepaliveTimeout = setTimeout(this.fire.bind(this), KEEPALIVE_PING_TIMEOUT);
  };

  _proto.fire = function fire() {
    KeepAlive.sendPing(this.socket);
    this.queue();
  };

  return KeepAlive;
}();

export { KeepAlive as default };